import React from 'react'
import { Edit } from 'react-admin'

import DynamicSplashScreenForm from './form'

const DynamicSplashScreenEdit = (props) => (
  <Edit {...props}>
    <DynamicSplashScreenForm isEdit={true} {...props} />
  </Edit>
)

export default DynamicSplashScreenEdit
